import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import authorObjIcon from "../../assets/images/author_obj.svg";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageProperties,
  defaultPageInitialContent,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("Author", {
  title: "Author",
  hideInSelectionDialogs: true,
  thumbnail: authorObjIcon,
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "title",
      "description",
      "image",
    ],
    "Author"
  ),
  properties: ["title", "description", "image", "hideInNavigation"],
  propertiesGroups: [socialCardsPropertiesGroup, metadataPropertiesGroup],
  initialContent: {
    ...metadataInitialContent,
    ...defaultPageInitialContent,
    title: "Author",
  },
});
